// A brand colour that is safe to put into CSS or HTML: hex, rgb()/hsl() with
// numbers only, or a colour name. Anything else (e.g. "</style>") is refused.
const SAFE_COLOUR = /^(#[0-9a-f]{3,8}|(?:rgb|hsl)a?\([\d\s.,%/+-]*\)|[a-z]{3,20})$/i;

export const isSafeColour = (value) => typeof value === 'string' && SAFE_COLOUR.test(value.trim());
